import { format } from "date-fns";
import { fr } from "date-fns/locale";

/**
 * Formatte une date sous la forme "22 Mai 2000"
 *
 * @param date : Date d'entrée a formatter
 */
export const formatDateLong = (date: any): string =>
  format(new Date(date), "d MMMM yyyy", { locale: fr });

/**
 * Formatte une date sous la forme "22/05/2000"
 *
 * @param date : Date d'entrée a formatter
 */
export const formatDateCourt = (date: any): string =>
  format(new Date(date), "dd/MM/yyyy", { locale: fr });

export const formatDateToJanuary = (date: any): string =>
  format(new Date(date), "yyyy-01-01", { locale: fr });

export const showMonth = (date: any): string =>
  format(new Date(date), "MMMM yyyy", { locale: fr });

export const formatApiDate = (date: any): string =>
  format(new Date(date), "yyyy-MM-dd", { locale: fr });
export const formatterEspaces = (numeroTelephone: string): string =>
  numeroTelephone ? numeroTelephone.replace(/\s/g, "") : numeroTelephone;

export const maskNumTelephone = () => {
  return [
    /[0]/,
    /[1-9]/,
    " ",
    /[0-9]/,
    /[0-9]/,
    " ",
    /[0-9]/,
    /[0-9]/,
    " ",
    /[0-9]/,
    /[0-9]/,
    " ",
    /[0-9]/,
    /[0-9]/,
  ];
};

export const maskNumSiret = () => {
  return [
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    " ",
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    " ",
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    " ",
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
  ];
};

export const capitalizeFirstLetter = (val: string) => {
  return val.charAt(0).toUpperCase() + val.slice(1);
};

export const calculSalaireNetMensuel = (
  salaireBrut: number,
  situation: string
) => {
  const sb = salaireBrut.toString().replaceAll(",", ".");
  const percent = situation === "SPR" ? 22 : 15;
  const minusPercent = (Number(sb) * percent) / 100;
  return Math.round(Number(sb) - minusPercent).toString();
};
